import { Component } from '@angular/core';
import { Links } from './links';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog, MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';

@Component({
    template: require('./viewrequests.component.html'),
    styles: [require('./viewrequests.component.scss')]
})

export class viewRequestsComponent {
    data: any = [];
    dialogRef;
    id: any;
    navLinks = [
        new Links('1', 'create', 'add_user_information', 'create/'),
        new Links('2', 'return', 'add_return_item_details', 'return/'),
        new Links('3', 'confirm_details', 'confirm_all_pickup', 'confirm/')
    ];
    userData: any;
    orderId: any;
    isApprover: boolean = false;
    isAdmin: boolean = false;
    pageName = 'viewRequest';
    param=''

    constructor(private router: Router, private commonService: CommonService, private route: ActivatedRoute, private sessionHandler: SessionHandler,
        private http: HttpService, private dialog: MdDialog) {
        this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
        
        this.param = '';
        // this.route.queryParams.subscribe(
            //     params => {
                //         console.log(params['action'])
                //         if(params['action']){
                    //             this.param =  params['action']      
                    //         }else{
                        //             this.param =  ""
                        //         }
                        //     //   this.param =  params['action']?params['action'].:'';
                        //       console.log(this.param)
                        
                        //     }
                        //   )
        this.param=this.route.snapshot.queryParamMap.get('action');
        console.log(this.param)

    }
    ngOnInit() {
        setTimeout(()=>{
        this.commonService.viewData.subscribe((value) => {
            this.data = value;
            this.setlinks(this.data);
            // console.log(this.data)
            // console.log(this.userData)
        });
        })

    }
    ngOnDestroy(){
        this.param = "";
        console.log(this.param)
    }

    public setlinks(data) {
        this.isApprover = false;
        this.isAdmin = false;
        if (data && data.sapReturnOrderId) {
            this.orderId = data.sapReturnOrderId;
            this.navLinks = [
                new Links('1', 'create', 'add_user_information', 'create/' + data.orderId),
                new Links('2', 'return', 'add_return_item_details', 'return/' + data.orderId),
                new Links('3', 'confirm_details', 'confirm_all_pickup', 'confirm/' + data.orderId)
            ];
            if (this.userData && this.userData.role && this.userData.role.length > 0) {
                // if (this.userData.role.includes('APPROVER')) {  /**Old logic */
                //     this.isApprover = true;
                // }
                
                // if (((this.userData.role.includes('COMMERCIAL_APPROVER') && data.returnOrderCategory=='COMMERCIAL') 
                // || (this.userData.role.includes('LOGISTIC_APPROVER') && data.returnOrderCategory=='LOGISTIC') 
                // || (this.userData.role.includes('END_CONSUMER_APPROVER') && data.returnOrderCategory=='CONSUMER'))) {
                //     if(this.userData.approverType && !this.userData.approverType.includes(data.orderSize)){
                //         this.navigateToDashbord();
                //     }else{
                //         this.isApprover = true;
                //     }
                // }
                let isAPPR = (this.userData.role.includes('COMMERCIAL_APPROVER') || this.userData.role.includes('LOGISTIC_APPROVER') || this.userData.role.includes('END_CONSUMER_APPROVER')|| this.userData.role.includes('GENRAL_EMEA_MANAGER_APPROVER')); 
                let sizeMatched = (this.userData.approverType && this.userData.approverType.includes(data.orderSize));
                if (this.userData.role.includes('ADMIN')) {
                    this.isAdmin = true;
                }
                else if(isAPPR){

                    this.isApprover = false;
                    if((this.userData.role.includes('COMMERCIAL_APPROVER') && data.returnOrderCategory=='COMMERCIAL') && sizeMatched){
                        this.isApprover = true;
                    } else if(this.userData.role.includes('LOGISTIC_APPROVER') && data.returnOrderCategory=='LOGISTIC' && sizeMatched){
                        this.isApprover=true;
                    }else if(this.userData.role.includes('END_CONSUMER_APPROVER') && data.returnOrderCategory=='CONSUMER' && sizeMatched){
                        this.isApprover=true;
                    }else if(this.userData.role.includes('GENRAL_EMEA_MANAGER_APPROVER')){
                        this.isApprover=true;
                    }
                    if(!this.isApprover)
                        this.navigateToDashbord();
                } 
                // if (this.userData.role.includes('ADMIN')) {
                //     this.isAdmin = true;
                // }
            }
            
        }
        console.log(this.param)
        if(( this.isApprover || this.isAdmin ) && data.status == 'SUBMIT' && data.orderSize !='SMALL'){
            if(this.param=='0'){
                this.updateStatus('rejected');
              }else if(this.param=='1'){
                this.updateStatus('approved');
              }
        }
    }

    public printLabel(id) {
        let data = {};
        data['orderId'] = id;

        this.http.postRequest(data, 'returnOrder/v1/printLabelPdf').subscribe(
            res => {
                this.savePrintResponse(id, res);
            },
            err => {
                //alert('Failed');
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed';

                }
                this.http.onEnd();
            }
        );
    }
navigateToDashbord(){
    this.dialogRef = this.dialog.open(dialogComponent);
    this.dialogRef.componentInstance.msg = 'You do not have access to View/Approve/Reject this Return.';
    this.dialogRef.afterClosed().subscribe(result => {
        this.router.navigateByUrl('/app/dashboard');
    });
}

    public savePrintResponse(id, res) {
        if (res.responseStatus == 'Success') {
            var link = document.createElement('a');
            link.href = res.fileUrl;
            link.download = 'file.pdf';
            // link.dispatchEvent(new MouseEvent('click'));
            window.open(res.fileUrl, "_blank");
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Unable to print label.';
        }
        this.http.onEnd();
    }

    public updateStatus(status) {
        let txtStatus;
        if (status == 'approved') {
            txtStatus = 'APPROVE';
        } else if (status == 'rejected') {
            txtStatus = 'REJECT';
        }
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Are you sure you want to ' + txtStatus + ' this request?';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let data = {};
                data['email'] = this.userData.email;
                data["userId"] = this.userData.userId;
                data['orderId'] = this.data.sapReturnOrderId;
                if (status == 'approved') {
                    data['status'] = 'APPR';
                } else if (status == 'rejected') {
                    data['status'] = 'REJE';
                }
                let today = new Date();
                let dd = ('0' + today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth() + 1)).slice(-2);
                let yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;

                this.http.postRequest(data, 'returnOrder/v1/updateReturnOrderStatus').subscribe(
                    res => {
                        this.saveResponse(res, status);
                    },
                    err => {
                        // alert('Submit Failed');
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Submit Failed';
                        this.http.onEnd();
                    }
                );
            }
            this.dialogRef = null;
        });
    }

    public saveResponse(res, status) {
        this.http.onEnd();
        if (res.status == 'Success') {
            if (status == 'approved') {
                status = 'APPROVED';
            } else if (status == 'rejected') {
                status = 'REJECTED';
            }
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Request successfully ' + status;
            this.dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.commonService.setData(null);
                    this.router.navigateByUrl('/app/dashboard');
                }
                this.dialogRef = null;
            });
        }
        if (res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/viewrequests.component.ts